import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useLinkMismatches } from '@/queries/clientMeetings'
import type { CompanyRow } from '@/types/clientMeetings'

function Group({ title, advice, companies }: { title: string; advice: string; companies: CompanyRow[] }) {
  if (!companies.length) return null
  return (
    <div className="space-y-1">
      <p className="text-sm font-medium text-etn-text">{title}</p>
      <p className="text-[12.5px] text-etn-text-soft">{advice}</p>
      <ul className="flex flex-wrap gap-1.5 pt-1">
        {companies.map(company => (
          <li key={company.companyId} className="rounded-etn-pill bg-etn-warning-subtle px-2.5 py-0.5 text-[12.5px] text-etn-warning-text">
            {company.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

export function LinkMismatchWarning() {
  const mismatches = useLinkMismatches().data?.data
  if (!mismatches || (!mismatches.notLinked.length && !mismatches.notOnHub.length)) return null

  return (
    <div className="container mx-auto max-w-4xl px-6 pb-6">
      <Card className="border-etn-warning-subtle">
        <CardHeader>
          <CardTitle>Client dashboards and Linear don't match</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Group title="On Client dashboards but not linked to Linear" advice="Link it to its Linear customer above." companies={mismatches.notLinked} />
          <Group title="Linked to Linear but not on Client dashboards" advice="Add it on Client dashboards with Add client." companies={mismatches.notOnHub} />
        </CardContent>
      </Card>
    </div>
  )
}
